/**
 * 앱이 쓰는 텍스트 스타일 표.
 *
 * c6 `Text` 와 `Field` 의 표시 축은 아직 `variant` 라 소비처는
 * `<Text variant={appTextModes[...]}>` 로 넘긴다. 값이 여기 **한 곳**에만 있으므로 c6 가 그
 * 축도 `mode` 로 옮기면 교체는 이 파일과 JSX 속성명뿐이다(규칙 §4).
 *
 * `app` 과 `modules` 가 함께 쓰는 값이라 어느 한쪽이 아니라 `shared` 가 갖는다 —
 * `modules` 는 `app` 을 import 하지 않기 때문이다(규칙 §3). `@/app/theme` 은 기존 소비처를 위해
 * 이 값을 그대로 다시 내보낸다.
 */
import { defaultTextVariants } from "@carbon6/c6-frontend-design";

export const appTextModes = defaultTextVariants;
